(function () {
    "use strict";

    angular.module("app").directive("hideWhenContentFits", HideWhenContentFitsDirective);

    function HideWhenContentFitsDirective() {
        return {
            restrict: "A",
            scope: {
                targetId: "@hideWhenContentFits"
            },
            link: function (scope, elm) {
                // Do not hide if no target was provided
                if (!scope.targetId)
                    return;

                const target = angular.element("#" + scope.targetId);

                if (!target[0])
                    return;

                const currentElement = elm[0];
                const targetElement = target[0];

                const observer = new MutationObserver(() => {
                    if (!isOverflowing(targetElement))
                        currentElement.classList.add("ng-hide");
                    else 
                        currentElement.classList.remove("ng-hide");
                });

                observer.observe(targetElement, { characterData: true, attributes: false, childList: false, subtree: true });
            }
        };

        function isOverflowing(targetElement) {
            return targetElement.offsetWidth < targetElement.scrollWidth;
        }
    }
})();
